import React, { useEffect, useState } from "react";
import { OrderVeiwApi, SettingsData } from "services/apiService";
import { OrderVeiwEditProps } from "types";
import { useLocation } from "react-router";
import "../../styles/OrderView.css";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import DynamicButton from "../../common/DynamicButton";
import { downloadInvoice } from "./downloadInvoice";
import config from "config";

const OrderVeiw: React.FC<OrderVeiwEditProps> = () => {
  const [orderDetails, setOrderDetails] = useState<any>(null);
  const [settingsData, setSettingsData] = useState([]);
  const location = useLocation();
  const { id } = location.state || {};

  useEffect(() => {
    if (id) fetchOrderDetails(id);
    getSettingDataDetails();
  }, [id]);

  const fetchOrderDetails = async (id: number) => {
    try {
      const response = await OrderVeiwApi(id);
      if (response.status_code === 200) {
        setOrderDetails(response.data);
      }
    } catch (error) {
      console.error("Error fetching order details:", error);
    }
  };

  const getSettingDataDetails = async () => {
    try {
      const response = await SettingsData();
      if (response.status_code === 200) {
        setSettingsData(response.data);
      }
    } catch (error) {}
  };
  const handleDownloadInvoice = (orderId) => {
    const logo = settingsData?.find(
      (item) => item?.key_name === "SITE_LOGO"
    )?.key_value;
    const address = settingsData?.find(
      (item) => item?.key_name === "ADDRESS_ONE"
    )?.key_value;
    const appImgae = config?.REACT_APP_IMAGE_URL + logo;
    downloadInvoice(orderId, appImgae, address);
  };
  return (
    <div className="order-view-container">
      <div className="order-header">
        <div>
          <p>
            <b>Order Date:</b> {orderDetails?.order_date}
          </p>
          <p>
            <b>Order Code:</b> {orderDetails?.order_code}
          </p>
        </div>
        <div style={{ textAlign: "right" }}>
          <p>
            <b>Customer Name:</b> {orderDetails?.customer_name}
          </p>
          <p>
            <b>Customer Email:</b> {orderDetails?.customer_email}
          </p>
        </div>
      </div>

      <div className="order-section">
        <div className="address-card">
          <h4>Billing Address</h4>
          <p>
            {orderDetails?.billing_address?.billing_name}, <br />
            {orderDetails?.billing_address?.billing_email}, <br />
            {orderDetails?.billing_address?.billing_phone_no}, <br />
            {orderDetails?.billing_address?.billing_address_line_one}, <br />
            {orderDetails?.billing_address?.billing_city},{" "}
            {orderDetails?.billing_address?.billing_state},
            {orderDetails?.billing_address?.billing_country}, <br />
            {orderDetails?.billing_address?.billing_pincode}
          </p>
        </div>

        <div className="address-card">
          <h4>Shipping Address</h4>
          <p>
            {orderDetails?.shipping_address?.shipping_name}, <br />
            {orderDetails?.shipping_address?.shipping_email}, <br />
            {orderDetails?.shipping_address?.shipping_phone_no}, <br />
            {orderDetails?.shipping_address?.shipping_address_line_one}, <br />
            {orderDetails?.shipping_address?.shipping_city},{" "}
            {orderDetails?.shipping_address?.shipping_state},
            {orderDetails?.shipping_address?.shipping_country}, <br />
            {orderDetails?.shipping_address?.shipping_pincode}
          </p>
        </div>
      </div>

      <div className="purchase-list">
        <h4>Purchase List</h4>
        <table className="order-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Product Name</th>
              <th>Variant Name</th>
              <th>Variant Value</th>
              <th>Price</th>
              <th>Discount Price</th>
              <th>Quantity</th>
              <th>Tax Name</th>
              <th>Tax Percentage</th>
              <th>Tax Amount</th>
              <th>Sales Amount</th>
              <th>Sub Total</th>
            </tr>
          </thead>
          <tbody>
            {orderDetails?.purchase_list?.map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{item.product_name}</td>
                <td>{item.variant_name}</td>
                <td>{item.variant_value}</td>
                <td>{item.price}</td>
                <td>{item.discount_price}</td>
                <td>{item.quantity}</td>
                <td>{item.tax_name}</td>
                <td>{item.tax_percentage}%</td>
                <td>{item.tax_amount}</td>
                <td>{item.sales_amount}</td>
                <td>{item.sub_total_amount}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="order-summary">
        <p>
          <b>Total Products:</b> {orderDetails?.total_products}
        </p>
        <p>
          <b>Total Count:</b> {orderDetails?.total_count}
        </p>
        <p>
          <b>Total Amount:</b> ₹{orderDetails?.total_amount}
        </p>
        <p>
          <b>Order Status:</b>{" "}
          <span
            className={`status-pill status-${orderDetails?.order_status.toLowerCase()}`}
          >
            {orderDetails?.order_status}
          </span>
        </p>
        <p>
          <b>Payment Status:</b>{" "}
          <span
            className={`status-pill status-${orderDetails?.payment_status.toLowerCase()}`}
          >
            {orderDetails?.payment_status}
          </span>
        </p>
        <p>
          <b>Payment Status:</b>{" "}
          <span
            className="btn btn-primary status-pill  rounded"
            onClick={() => handleDownloadInvoice(orderDetails.order_id)}
          >
            {" "}
            <DynamicButton
              icon={faDownload}
              iconStyle={{ color: "white" }}
              style={{
                padding: "0",
                border: "none",
                background: "none",
                cursor: "pointer",
                margin: "2px",
              }}
            />
            Download
          </span>
        </p>
      </div>
    </div>
  );
};

export default OrderVeiw;
